// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__7D1_c","container":"styles_container__3aHFI","title":"styles_title__2UBCq","wrapper":"styles_wrapper__1XePs","answer":"styles_answer__2suqY"};